import FinishRegistration from './finish-registration';

export default FinishRegistration;
